import {
  UploadProjectState,
  UploadProjectFailureAction,
  UploadProjectActions,
} from './types';
import * as actionTypes from './actionTypes';

const handleUploadProjectRequest = (state: UploadProjectState) => ({
  ...state,
  isLoading: true,
  error: '',
  loaded: false,
  clusters: [],
});

const handleUploadProjectSuccess = (state: UploadProjectState) => ({
  ...state,
  isLoading: false,
  loaded: true,
});

const handleUploadProjectFailure = (
  state: UploadProjectState,
  action: UploadProjectFailureAction,
) => ({
  ...state,
  isLoading: false,
  error: action.payload.error,
});

const reducer = (state: UploadProjectState, action: UploadProjectActions) => {
  switch (action.type) {
    case actionTypes.UPLOAD_PROJECT_REQUEST:
      return handleUploadProjectRequest(state);
    case actionTypes.UPLOAD_PROJECT_SUCCESS:
      return handleUploadProjectSuccess(state);
    case actionTypes.UPLOAD_PROJECT_FAILURE:
      return handleUploadProjectFailure(state, action);
    default:
      return state;
  }
};

export default reducer;
